module.exports = __webpack_public_path__ + "img/num2.864a5147.png";